import React from 'react';
import { message, notification } from 'antd';
import { ErrorShowType, ResultType } from './request';

function ShowError({ code, showType, msg, data }: ResultType): void {
  if (showType === ErrorShowType.NOTIFICATION || code === -100) {
    if (Array.isArray(data)) {
      const description = data.map((i, index) => <div key={index}>{`${index + 1}. ${i}`}</div>);
      notification.error({
        message: msg,
        description,
        duration: null,
      });
    } else {
      notification.error({
        message: msg,
      });
    }
  } else if (showType === ErrorShowType.WARN_MESSAGE) {
    message.warn(msg);
  } else if (showType === ErrorShowType.SILENT) {
    console.error(msg);
  } else {
    message.error(msg);
  }
}

export default ShowError;
